import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Client } from '../../../api/api-reference';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-desktop-login',
  standalone: true,
  imports: [],
  templateUrl: './desktop-login.component.html',
  styleUrl: './desktop-login.component.scss'
})
export class DesktopLoginComponent implements OnInit {
  redirectUri: string | null = null;
  version: string | null = null;

  constructor(private authService: AuthService,
      private client: Client,
      private route: ActivatedRoute,
      @Inject(DOCUMENT) private document: Document,) { }


  ngOnInit(): void {
    this.login()
  }

  login(retryCount: number = 2): void {
    if (environment.useOpenIddict) {
      this.redirectUri = this.route.snapshot.queryParamMap.get('redirect_uri');
      this.version = this.route.snapshot.queryParamMap.get('version');
      localStorage.setItem('redirect-uri', this.redirectUri!);
      localStorage.setItem('desktop-version', this.version!);

      this.client.identityLoginDesktopApp().subscribe({
        next: (response) => {
          if (typeof response === 'string') {
            this.document.location.href = response;
          }
        },
        error: (err) => {
          this.authService.logout();

          if (retryCount > 0) {
            this.login(retryCount - 1);
          } else {
            console.error('Login failed after 2 retries:', err);
          }
        },
      });
    } else {
      const userInput = window.prompt('Please enter your e-mail:', '');
      if (userInput !== null && userInput.trim() !== '') {
        this.client.getToken(userInput).subscribe({
          next: (result) => {
            localStorage.setItem('token', result);
          },
          error: (err) => {
            // this.toastr.warning(err);
          },
        });
      } else {
        console.log('Unauthorized!.');
      }
    }
  }
}
